import React, { useEffect, useState } from 'react';
import { Table, Tag } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { TStore, useAppDispatch } from '../store';
import { getFleetAverage } from '../actions/fleetAverageAction';
import { setSelectedVessel } from '../slices/averageFleetSlice';

const OverviewTable: React.FC = () => {
  const dispatch = useAppDispatch();
  const { error: averageFleetError, data: fleetData } = useSelector((state: TStore) => state.averageFleetDetails);
  const [cleanFleetData, setCleanFleetData] = useState<any>();

  useEffect(() => {
    dispatch(getFleetAverage());
  }, []);

  useEffect(() => {
    if (averageFleetError) {
      console.error(averageFleetError);
    }
    if(fleetData) {
      setCleanFleetData(
        fleetData.filter(d =>
          d && (
            Number.isFinite(d.averageStrain) ||
            Number.isFinite(d.averageSleep) ||
            Number.isFinite(d.averageRecovery)
          )
        )
      );
    }
  }, [fleetData, averageFleetError]);

  const columns = [
    {
      title: 'Ship Name',
      dataIndex: 'shipName',
      key: 'shipName',
      render: (text: string) => {
      const shipData = cleanFleetData.find((d: any) =>
        d.shipName === text &&
        (
          Number.isFinite(d.averageStrain) ||
          Number.isFinite(d.averageSleep) ||
          Number.isFinite(d.averageRecovery)
        )
      );
        return (
          <>
            {shipData?.averageStrain != null && shipData?.averageRecovery != null && shipData?.averageSleep != null ?
              <Link 
                style={{ fontSize: '12px' }} 
                to={'/dashboard'} 
                onClick={() => dispatch(setSelectedVessel(text))}
              >
                {text}
              </Link>
            :
              <Link 
                style={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }} 
                to={'/'} 
                onClick={(e) => e.preventDefault()}
              >
                {text}
              </Link>
            }
          </>
        )
      },
    },
    {
      title: 'Ship Type',
      dataIndex: 'shipType',
      key: 'shipType',
      render: (text: string) => <div style={{ fontSize: '12px' }}>{text}</div>,
    },
    {
      title: 'Strain',
      key: 'averageStrain',
      dataIndex: 'averageStrain',
      render: (avgStrain: number) => {
        var color;
        return (
          (color = avgStrain > 14 ? 'orange' : 'green'),
          (
            <Tag color={color} key="cond1" style={{ fontSize: '12px' }}>
              {avgStrain?.toFixed(2)}
            </Tag>
          )
        );
      },
    },
    {
      title: 'Recovery',
      key: 'averageRecovery',
      dataIndex: 'averageRecovery',
      render: (avgRecovery: number) => {
        var color;
        return (
          (color = avgRecovery > 50 ? 'green' : 'orange'),
          (
            <Tag color={color} key="cond2" style={{ fontSize: '12px' }}>
              {avgRecovery?.toFixed(2)}
            </Tag>
          )
        );
      },
    },
    {
      title: 'Sleep',
      key: 'averageSleep',
      dataIndex: 'averageSleep',
      render: (avgSleep: number) => {
        var color;
        return (
          (color = avgSleep > 50 ? 'green' : 'orange'),
          (
            <Tag color={color} key="cond3" style={{ fontSize: '12px' }}>
              {avgSleep?.toFixed(2)}
            </Tag>
          )
        );
      },
    },
  ];

  return (
    <div className="overview__table">
        <Table columns={columns} dataSource={cleanFleetData} rowKey={obj => obj.shipId} />
    </div>
  );
};

export default OverviewTable;
